module.exports = __webpack_public_path__ + "static/yes-0010d795fb533d31b8aa76333ee7941c.png";